import { Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PanelCollapse from '../../../../../../../shared/components/collapse/PanelCollapse';
import { FormCheckBox, FormInputDate, FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import FormSwitch from '../../../../../../../shared/components/crmFormElement/FormSwitch/FormSwitch';
import { GO_DIGIT_DYNAMIC_TREATMENT_DETAILS_JSON, GUTTOR_SPACE, MAX_CHARACTERS_LENGTH_LIMIT, VIDAL_DYNAMIC_TREATMENT_DETAILS_JSON } from '../../../../../../../shared/constants/commonConstants';
import { useForceUpdate } from '../../../../../../../shared/hooks/useForceUpdate';
import { useSetFormControlConfig } from '../../../../../../../shared/hooks/useSetFormControlConfig';
import { RootState } from '../../../../../../../store';
import { customGTMEvent, getIsPageNameDetail, handleUserFocus  } from '../../../../service/crmUtils';
import { PayerInitialState } from '../../../../../../../store/models/payerListModel';
import { NewAdmissionState } from '../../../../../../../store/models/newAdmissionModel';
import { formInputStates, OTHER_INJURY_REASON_OPTIONS, ICICI_ARTEMIS_INJURY_REASON_OPTIONS } from '../../../../../../../shared/constants/crmConstants';
import { endOfDay, isAfter } from 'date-fns';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';

const AccidentCard = ({ isLoading, form, location: { pathname } }: any): ReactElement => {
  const [claimDetailBackup, setClaimDetailBackup] = useState<any>({});
  const {
    admissionDetails: { claimDetails: claimDetail },
  } = useSelector((state: RootState): RootState => state);
  const { payer, formControlConfig } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const payerConfigValues = Object.values(formControlConfig);
  const [mandatoryFIR, setMandatoryFIR] = useState(false);
  const [mandatoryPTD, setMandatoryPTD] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const { showAccidentCard, admissionFormVal } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const {
    dateOfInjury, firNumber, isItARta, injuryOrDeseaseCaused, isReportedToPolice,
    testConductedToEstablishedThis, reasonForInjury, isMLC, accidentDueTo,
  } = claimDetail;
  const momentTime = require('moment');
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );

  const forceUpdate = useForceUpdate();
  const getValueBasedOnConfig = useSetFormControlConfig();
  const [activeKeyProp, setActiveKeyProp] = useState<any[]>([]);
  const { selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const [inputStates, setInputStates] = useState(formInputStates.accidentCardForm);
  const caseDetails = selectedPatientDetail?.caseDetails;
  const commonDetail = { isLoading, form, claimDetailBackup };
  const GO_DIGIT_PAYER = payerConfigValues?.some(({ options }: any): boolean => options === 'GO_DIGIT_MATERNITY_TYPE_OPTIONS');
  const ARTEMIS_PAYER = payerConfigValues.filter(({type}: any): boolean => type === 'ARTEMIS').length;
  const isOrionIntegrationEnabledProvider = appdetails.getIsOrionIntegrationEnabled();

  useEffect((): any => {
    if (claimDetail && Object.keys(claimDetail).length) {
      const formValues = {
        dateOfInjury, firNumber, isItARta, injuryOrDeseaseCaused, isReportedToPolice,
        testConductedToEstablishedThis, reasonForInjury, isMLC, accidentDueTo,
      };
      // moment conversion fo date on injury
      if (!getIsPageNameDetail(pathname)) {
        formValues.dateOfInjury = formValues?.dateOfInjury ? momentTime?.(formValues?.dateOfInjury) : null;
      }
      const updatedFormValues = getValueBasedOnConfig(getIsPageNameDetail(pathname), formValues);
      setClaimDetailBackup(updatedFormValues);
      form.setFieldsValue(updatedFormValues);
      forceUpdate();
    }
  }, [claimDetail]);
  useEffect((): any => {
    if (showAccidentCard) {
      setActiveKeyProp([1]);
    } else {
      setActiveKeyProp([]);
    }
  }, [showAccidentCard]);

  useEffect((): any => {
    if (admissionFormVal?.treatmentDetail?.permanentDisability?.[0] === 'Yes' ||
    claimDetail?.permanentDisability === 'Yes') {
      setMandatoryPTD(true);
    } else {
      setMandatoryPTD(false);
    }
  }, []);

  const checkVisibleFields = (event: any, key: any): boolean => {
    let isRequired = false;   // function to set fields dynamically
    const requiredJson = GO_DIGIT_PAYER ? GO_DIGIT_DYNAMIC_TREATMENT_DETAILS_JSON : VIDAL_DYNAMIC_TREATMENT_DETAILS_JSON;
    if (form.getFieldValue(event) !== undefined &&
      form.getFieldValue(event) !== null && requiredJson?.[event]?.[form?.getFieldValue(event)] !== undefined) {
      const objectKeys = Object.values(requiredJson?.[event]?.[form?.getFieldValue(event)]);
      isRequired = objectKeys?.includes(key);
    }
    return isRequired;
  };
  const onChangeFieldsFIR = (ev: any): any => {
    ev === true  ?
    setMandatoryFIR(true) : setMandatoryFIR(false);
  };
  const onChangeMLC = (ev: any): any => {  // set FIR if MLC case
    ev?.target?.value === true ?
    setMandatoryFIR(true) : setMandatoryFIR(false);
  };

  const onChangeDisability = (ev: any): any => {
    ev?.target?.checked === true ?
    setMandatoryPTD(true) : setMandatoryPTD(false);
  };

  const onChange = (): any => {
     setIsHidden(!isHidden);
  };
  const handleExpandCollapseEvent = (isActive: any): void => {
    if (isActive) {
      customGTMEvent({
        event: 'INJURY_DETAILS_FORM_EXPAND',
      });
    }
  };

  return (
    <PanelCollapse
      accordion={true}
      expandIconPosition="right"
      defaultActiveKey={[]}
      keyName="1"
      activeKey = {activeKeyProp?.length > 0 ? activeKeyProp : undefined}
      header="In case of injury, Please provide following details"
      onChange={handleExpandCollapseEvent}
    >
      <Row gutter={GUTTOR_SPACE}>
        <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfInjury',
          required: checkVisibleFields('hospitalizationReason', 'dateOfInjury'),
          size: 12,
          disabledDate: (current: Date): boolean => isAfter(new Date(current), endOfDay(new Date())),
          onFocus: (): void => handleUserFocus('dateOfInjury', setInputStates, true ),
          onBlur: (): void => handleUserFocus('dateOfInjury', setInputStates, false ),
          isShowSuggestedValue: inputStates.dateOfInjury.isShowSuggestedValue,
        }} />
        <FormSelect detail ={{
          ...commonDetail,
          key: 'reasonForInjury',
          size: 12,
          required: checkVisibleFields('hospitalizationReason', 'reasonForInjury'),
          options: (isOrionIntegrationEnabledProvider && ARTEMIS_PAYER) ? ICICI_ARTEMIS_INJURY_REASON_OPTIONS :
          OTHER_INJURY_REASON_OPTIONS,
          onChange,
          onFocus: (): void => handleUserFocus('reasonForInjury', setInputStates, true ),
          onBlur: (): void => handleUserFocus('reasonForInjury', setInputStates, false ),
          isShowSuggestedValue: inputStates.reasonForInjury.isShowSuggestedValue,
        }}/>
        <FormCheckBox
        detail={{
          ...commonDetail,
          key: 'isMLC',
          size: 12,
          required: false,
          options: [{ value: 'Yes', name: 'Yes', onChange: onChangeMLC }],
          hidden: !checkVisibleFields('reasonForInjury', 'isMLC'),
          isShowSuggestedValue: !!caseDetails,
        }}
      />
        <FormCheckBox
          detail={{
            ...commonDetail,
            key: 'permanentDisability',
            size: 12,
            required: false,
            options: [{ value: 'Yes', name: 'Yes', onChange: onChangeDisability }],
            hidden: !(checkVisibleFields('reasonForInjury', 'permanentDisability') && checkVisibleFields('conditionOnDischarge', 'permanentDisability')),
          }}
        />
        <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfCommencement',
          required: false,
          size: 12,
          hidden: !mandatoryPTD,
          disabledDate: (current: Date): boolean => isAfter(new Date(current), endOfDay(new Date())),
        }} />
         <FormSelect detail ={{
          ...commonDetail,
          key: 'accidentDueTo',
          required: true,
          size: 12,
          options: ['Others', 'Road Traffic Accident', 'Self Accident'],
          hidden: !checkVisibleFields('reasonForInjury', 'accidentDueTo'),
          onFocus: (): void => handleUserFocus('accidentDueTo', setInputStates, true ),
          onBlur: (): void => handleUserFocus('accidentDueTo', setInputStates, false ),
          isShowSuggestedValue: inputStates.accidentDueTo.isShowSuggestedValue,
        }}/>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'firNumber',
          size: 12,
          maxLength: (isOrionIntegrationEnabledProvider && ARTEMIS_PAYER) ? MAX_CHARACTERS_LENGTH_LIMIT  : 30,
          onlyAlphaNumeric: true,
          required: mandatoryFIR,
          onFocus: (): any => handleUserFocus('firNumber', setInputStates, true ),
          onBlur: (): any => handleUserFocus('firNumber', setInputStates, false ),
          isShowSuggestedValue: inputStates.firNumber.isShowSuggestedValue,
        }} />
        <FormSwitch detail={{
          ...commonDetail,
          key: 'isItARta',
          size: 12,
          isShowSuggestedValue: !!caseDetails,
        }} />
        <FormSwitch detail={{
          ...commonDetail,
          key: 'injuryOrDeseaseCaused',
          size: 12,
          isShowSuggestedValue: !!caseDetails,
        }} />
        <FormSwitch detail={{
          ...commonDetail,
          key: 'isReportedToPolice',
          size: 12,
          labelClass: 'mb-0',
          onChange:  payer.shortName === 'CMSGI' ?  onChangeFieldsFIR : undefined,
          isShowSuggestedValue: !!caseDetails,
        }} />
        <FormSwitch detail={{
          ...commonDetail,
          key: 'testConductedToEstablishedThis',
          size: 12,
          labelClass: 'mb-0',
          isShowSuggestedValue: !!caseDetails,
        }} />
      </Row>
    </PanelCollapse>
  );
};

export default withRouter(AccidentCard);
